import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '../css/app.css';

// Chunk load failures during navigation are recovered in the router's onError
// hook, which reloads to the intended destination rather than the current URL.
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
});

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
